import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import QuantitySelector from "../components/QuantitySelector";
import {
  increaseQuantity,
  decreaseQuantity,
  removeFromCart,
} from "../redux/store/cartSlice";
import { IoMdClose } from "react-icons/io";
import api from "../utilis/api";
import { toast } from "react-toastify";
import { server } from "../utilis/constant";
const Payment = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [order, setOrder] = useState({});
  const { token, user } = useSelector((state) => state.user);
  const { name } = location.state;

  const handlePayment = () => {
    if (isLoading || isSuccess) return;

    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      setIsSuccess(true);

      navigate("/success", {
        state: {
          order: order?.[0], // or order[0]
        },
      });
    }, 4000);
  };

  const dispatch = useDispatch();
  const { cartItems, totalPrice, quantity } = useSelector(
    (state) => state.cart,
  );
  const payload = { userId: user?._id || "", guestName: name };
  console.log(payload);
  const getOrders = async () => {
    try {
      const { data } = await api.get("/orders", {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(data);
      setOrder(data.data); // data.data is the orders array directly
    } catch (err) {
      console.error("Orders fetch failed:", err);
      toast.error("Failed to load orders.");
    }
  };
  useEffect(() => {
    getOrders();
  }, [token]);

  const subtotalPrice = cartItems.reduce(
    (acc, item) => acc + item.variants?.[0].price * item.quantity,
    0,
  );
  const currentOrder = order?.[0];
  return (
    <>
      <div className="bg-black">
        <Navbar />
      </div>

      {/* Breadcrumb */}
      <div className="bg-white border-b px-4 sm:px-10 lg:px-20 py-4 text-sm text-gray-500">
        <span className="text-gray-800 font-medium">
          <Link to="/">Home</Link>
        </span>
        <span className="mx-2 text-gray-400">/</span>
        Payment
      </div>

      <div className="bg-gray-50 min-h-screen py-10 px-4 sm:px-6 md:px-10 lg:px-20">
        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
            Secure Payment
          </h1>
          <p className="text-gray-500 mt-2 text-sm sm:text-base">
            Complete your purchase safely
          </p>
        </div>

        {/* TOP SECTION */}
        <div className="flex flex-col lg:flex-row gap-10 items-start">
          {/* PAYMENT FORM */}
          <div className="w-full lg:w-1/2">
            <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-800 mb-6">
                Payment Details
              </h2>

              <div className="space-y-4">
                <input
                  type="text"
                  placeholder="Card Number"
                  className="w-full border border-gray-200 rounded-xl p-3 focus:outline-none focus:ring-2 focus:ring-black"
                />

                <div className="flex gap-4">
                  <input
                    type="text"
                    placeholder="MM/YY"
                    className="w-1/2 border border-gray-200 rounded-xl p-3 focus:outline-none focus:ring-2 focus:ring-black"
                  />

                  <input
                    type="text"
                    placeholder="CVC"
                    className="w-1/2 border border-gray-200 rounded-xl p-3 focus:outline-none focus:ring-2 focus:ring-black"
                  />
                </div>
              </div>

              <button
                onClick={handlePayment}
                disabled={isLoading || isSuccess}
                className={`
              w-full mt-6 py-4 rounded-2xl font-semibold transition
              ${
                isSuccess
                  ? "bg-green-600 text-white"
                  : isLoading
                    ? "bg-gray-400 text-white cursor-not-allowed"
                    : "bg-black text-white hover:bg-gray-800 active:scale-95"
              }
            `}
              >
                {isLoading
                  ? "Processing Payment..."
                  : isSuccess
                    ? "Payment Successful ✓"
                    : "Pay Now"}
              </button>

              <p className="text-xs text-gray-400 text-center mt-4">
                Your payment is encrypted & secure
              </p>
            </div>
          </div>

          {/* ORDER SUMMARY */}
          <div className="w-full lg:w-1/2">
            <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-6 lg:sticky lg:top-10">
              <h2 className="text-xl font-bold text-gray-800 mb-6">
                Order Summary
              </h2>

              <div className="space-y-4 text-gray-700">
                <div className="flex justify-between">
                  <span>Subtotal</span>
                  <span>${currentOrder?.itemsPrice?.toFixed(2)}</span>
                </div>

                <div className="flex justify-between">
                  <span>Delivery</span>
                  <span>${currentOrder?.shippingPrice}</span>
                </div>

                <div className="border-t pt-4 flex justify-between font-bold text-lg text-gray-900">
                  <span>Total</span>
                  <span>${currentOrder?.totalPrice?.toFixed(2)}</span>
                </div>
              </div>

              <button
                onClick={handlePayment}
                disabled={isLoading || isSuccess}
                className="w-full mt-6 py-4 rounded-2xl bg-red-500 text-white font-semibold
              hover:bg-red-600 transition active:scale-95 disabled:opacity-50"
              >
                {isSuccess ? "Payment Completed" : "Checkout"}
              </button>
            </div>
          </div>
        </div>

        {/* ORDER ITEMS TABLE */}
        <div className="mt-12 bg-white rounded-3xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b bg-gray-50">
            <h2 className="font-bold text-gray-800">Order Items</h2>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full min-w-[650px]">
              <thead className="text-left text-xs uppercase text-gray-500 bg-gray-50">
                <tr>
                  <th className="px-6 py-4">Product</th>
                  <th className="px-6 py-4 text-center">Qty</th>
                  <th className="px-6 py-4">Price</th>
                  <th className="px-6 py-4">Total</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {currentOrder?.orderItems?.map((data) => (
                  <tr key={data.id} className="hover:bg-gray-50 transition">
                    {/* Product */}
                    <td className="px-6 py-5">
                      <div className="flex items-center gap-4">
                        <div className="w-14 h-14 rounded-xl overflow-hidden bg-gray-100">
                          <img
                            src={`${server}/${data.product.image}`}
                            alt={data.product.title}
                            className="w-full h-full object-cover"
                          />
                        </div>

                        <div>
                          <h1 className="font-semibold text-gray-900">
                            {data.product.title}
                          </h1>
                          <p className="text-xs text-gray-500">
                            {data.product.vendor}
                          </p>
                        </div>
                      </div>
                    </td>

                    {/* Qty */}
                    <td className="text-center font-medium">{data.quantity}</td>

                    {/* Price */}
                    <td className="text-gray-700 font-medium">${data.price}</td>

                    {/* Total */}
                    <td className="font-bold text-gray-900">
                      ${(data.price * data.quantity).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Payment;
